import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { createSelector, createStructuredSelector } from 'reselect'
import uniq from 'lodash/uniq'
import Why from '../components/Why'
import AppLinks from '../components/AppLinks'
import MobileRadioBlock from '../components/MobileRadioBlock'
import Subscription from '../components/Subscription'
import SubscriptionPurchaseOptions from '../components/SubscriptionPurchaseOptions'
// import NotLoseSubscribtion from '../components/NotLoseSubscribtion'
import { profileSelector } from '../reducers/profile'
import { SUBSCRIPTION_PRODUCT_NEW_TYPES_BY_PRODUCT } from '../constants/ProductsNew'

const mocks = [
  {
    id: '616521',
    type: 'pack',
    product: 'monthly',
    kind: 'web_subscription',
    lastPaymentProduct: 'monthly',
    active: true,
    promoCode: null,
    expiresAt: 1744920000,
    cancelledAt: 1754920000,
    currency: 'RUB',
    priceCents: 199900,
    nextPriceCents: 199900,
    extraTipCents: 0,
    introductoryPriceCents: null,
    resumingUnavailable: true
  },
  {
    id: '616521',
    type: 'pack',
    product: 'monthly',
    kind: 'promo_subscription',
    lastPaymentProduct: 'monthly',
    active: true,
    promoCode: "МОЙ ЁЖ",
    expiresAt: 1744920000,
    cancelledAt: null,
    currency: 'RUB',
    priceCents: 199900,
    nextPriceCents: 199900,
    extraTipCents: 0,
    introductoryPriceCents: null
  },
  {
    id: '616521',
    type: 'radio',
    product: 'yearly',
    kind: 'google_subscription',
    lastPaymentProduct: 'yearly',
    active: true,
    promoCode: null,
    expiresAt: 1744920000,
    cancelledAt: null,
    currency: 'RUB',
    priceCents: 199900,
    nextPriceCents: 199900,
    extraTipCents: 0,
    introductoryPriceCents: null
  },
  {
    id: '616521',
    type: 'radio',
    product: 'triennial',
    kind: 'web_subscription',
    lastPaymentProduct: 'yearly',
    active: true,
    promoCode: null,
    expiresAt: 1744920000,
    cancelledAt: null,
    currency: 'RUB',
    priceCents: 199900,
    nextPriceCents: 449900,
    extraTipCents: 0,
    introductoryPriceCents: null
  },
  {
    id: '616521',
    type: 'radio',
    product: 'yearly',
    kind: 'web_subscription',
    lastPaymentProduct: 'yearly',
    active: true,
    promoCode: null,
    expiresAt: 1744920000,
    cancelledAt: null,
    currency: 'RUB',
    priceCents: 199900,
    nextPriceCents: 199900,
    extraTipCents: 0,
    introductoryPriceCents: null
  },
  {
    id: '616521',
    type: 'radio',
    product: 'yearly',
    kind: 'web_subscription',
    lastPaymentProduct: 'yearly',
    active: true,
    promoCode: null,
    expiresAt: 1744920000,
    cancelledAt: null,
    currency: 'RUB',
    priceCents: 199900,
    nextPriceCents: 199900,
    extraTipCents: 0,
    introductoryPriceCents: null,
    withSelect: true,
    initIsSubscriptionManagement: true
  },
  {
    id: '616521',
    type: 'radio',
    product: 'yearly',
    kind: 'web_subscription',
    lastPaymentProduct: 'yearly',
    active: true,
    promoCode: null,
    expiresAt: 1744920000,
    cancelledAt: null,
    currency: 'RUB',
    priceCents: 199900,
    nextPriceCents: 199900,
    extraTipCents: 10,
    introductoryPriceCents: null,
    withSelect: true,
    initIsSubscriptionManagement: true
  },
  {
    id: '616521',
    type: 'radio',
    product: 'yearly',
    kind: 'web_subscription',
    lastPaymentProduct: 'yearly',
    active: true,
    promoCode: null,
    expiresAt: 1744920000,
    cancelledAt: 1754920000,
    currency: 'RUB',
    priceCents: 199900,
    nextPriceCents: 199900,
    extraTipCents: 0,
    introductoryPriceCents: null
  },
]

const BLANK_ARRAY = []
const subscriptionsSelector = createSelector([profileSelector], profile => profile.subscriptions || BLANK_ARRAY)

function SubscriptionTab({ subscriptions }) {
  const [useMocks, setUseMocks] = useState(false)

  useEffect(() => {
    // Check for mock=1 in URL query parameters
    const params = new URLSearchParams(window.location.search)
    setUseMocks(params.get('mock') === '1')
  }, [])

  // Use mocks or actual subscriptions based on URL parameter
  const subscriptionsToUse = useMocks ? mocks : subscriptions

  const activeAppleSubscriptionTypes = uniq(
    subscriptionsToUse
      .filter(s => s.kind === 'apple_subscription')
      .map(s => SUBSCRIPTION_PRODUCT_NEW_TYPES_BY_PRODUCT[s.product])
  )
  const activeGoogleSubscriptionTypes = uniq(
    subscriptionsToUse
      .filter(s => s.kind === 'google_subscription')
      .map(s => SUBSCRIPTION_PRODUCT_NEW_TYPES_BY_PRODUCT[s.product])
  )

  const activeWebSubscriptionTypes = uniq(
    subscriptionsToUse
      .filter(s => s.kind === 'web_subscription')
      .map(s => SUBSCRIPTION_PRODUCT_NEW_TYPES_BY_PRODUCT[s.product])
  )

  const allSubscriptionTypes = uniq(subscriptionsToUse.map(s => SUBSCRIPTION_PRODUCT_NEW_TYPES_BY_PRODUCT[s.product]))
  // скрываем блок с покупкой веб-подписки если уже все виды подписок есть
  const purchaseOptionsIsActive =
    activeWebSubscriptionTypes.includes('pack') &&
    activeWebSubscriptionTypes.includes('radio') &&
    activeWebSubscriptionTypes.includes('kids')

  // скрываем блок если куплена Р+Г навсегда
  const foreverPack = subscriptionsToUse.find(s => s.product === 'pack_lifetime')

  return (
    <>
      {/*<NotLoseSubscribtion />*/}
      <Why />
      {subscriptionsToUse.map((s, index) => (
        <Subscription
          {...s}
          key={s.id || index}
          index={index}
          type={SUBSCRIPTION_PRODUCT_NEW_TYPES_BY_PRODUCT[s.product] || s.type}
        />
      ))}
      {!purchaseOptionsIsActive && !foreverPack && (
        <SubscriptionPurchaseOptions
          activeAppleSubscriptionTypes={activeAppleSubscriptionTypes}
          activeGoogleSubscriptionTypes={activeGoogleSubscriptionTypes}
          activeWebSubscriptionTypes={activeWebSubscriptionTypes}
          subscriptionTypes={allSubscriptionTypes}
        />
      )}
      <AppLinks />
      <MobileRadioBlock />
    </>
  )
}

const mapStateToProps = createStructuredSelector({
  profile: profileSelector,
  subscriptions: subscriptionsSelector
})

export default connect(mapStateToProps)(SubscriptionTab)
